import { cloneElement } from "react"

const Hoverable = ({children}) => {
    return cloneElement(children, {'data-hover': 1})
}

export default Hoverable